import { useEffect } from "react";
import { Link } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
import { t, tNode } from "../services/i18n";
import { track } from "../services/analytics";

interface Article { title: string; body: string; }

export default function HelpPage() {
  const articles = tNode<Record<string, Article>>("helpPage.articles", {});
  useEffect(() => { track("help_viewed"); }, []);

  return (
    <>
      <AppHeader title={t("helpPage.title")} />
      <div className="page page--with-nav">
        <ul className="help-list">
          {Object.entries(articles).map(([slug, a]) => (
            <li className="help-item" key={slug}>
              <Link to={`/help/${slug}`}>
                {a.title} <span aria-hidden="true">&#8250;</span>
              </Link>
            </li>
          ))}
          <li className="help-item">
            <Link to="/safety">
              {t("safety.title")} <span aria-hidden="true">&#8250;</span>
            </Link>
          </li>
          <li className="help-item">
            <a
              href="mailto:info@viraball.com"
              onClick={() => track("support_clicked")}
            >
              {t("helpPage.contact")} <span aria-hidden="true">&#8250;</span>
            </a>
          </li>
        </ul>
      </div>
      <BottomNavigation />
    </>
  );
}
